export default __webpack_public_path__ + "static/media/cropped-crop.0b8b7460.jpg";